var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("aside", { staticClass: "is-faqs" }, [
    _c("div", {
      staticClass: "faqs-overlay",
      on: { click: _vm.hideUserSettings },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "faqs-wrapper" }, [
      _c("h2", [_vm._v("Einstellungen")]),
      _vm._v(" "),
      _c("div", { staticClass: "field" }, [
        _c("label", { staticClass: "label" }, [_vm._v("MAILBOX")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "control" },
          [
            _c("email-select", {
              attrs: { save: false },
              model: {
                value: _vm.emailSelected,
                callback: function ($$v) {
                  _vm.emailSelected = $$v
                },
                expression: "emailSelected",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "field" }, [
        _c("label", { staticClass: "label" }, [_vm._v("SCHECKBUCH")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "control" },
          [
            _c("check-book-select", {
              model: {
                value: _vm.checkBook,
                callback: function ($$v) {
                  _vm.checkBook = $$v
                },
                expression: "checkBook",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "field" }, [
        _c("label", { staticClass: "label" }, [_vm._v("AKTIVE NUTZER")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "control" },
          [
            _c(
              "toggle-switch",
              {
                model: {
                  value: _vm.allUsers,
                  callback: function ($$v) {
                    _vm.allUsers = $$v
                  },
                  expression: "allUsers",
                },
              },
              [
                _c("option", { domProps: { value: false } }, [
                  _vm._v("nur aktive User anzeigen"),
                ]),
                _vm._v(" "),
                _c("option", { domProps: { value: true } }, [
                  _vm._v("alle User anzeigen"),
                ]),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "field" }, [
        _c("label", { staticClass: "label" }, [
          _vm._v("Alle Emails durchsuchen"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "control" },
          [
            _c(
              "toggle-switch",
              {
                model: {
                  value: _vm.allUserEmails,
                  callback: function ($$v) {
                    _vm.allUserEmails = $$v
                  },
                  expression: "allUserEmails",
                },
              },
              [
                _c("option", { domProps: { value: false } }, [
                  _vm._v("nur eigene Emails durchsuchen"),
                ]),
                _vm._v(" "),
                _c("option", { domProps: { value: true } }, [
                  _vm._v("alle Emails durchsuchen"),
                ]),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "field is-ai-access" },
        [
          _c("label", { staticClass: "label" }, [_vm._v("KI-ZUGANG")]),
          _vm._v(" "),
          _c("p", { staticClass: "help" }, [
            _vm._v(
              "Persönliches Token für Codex und Claude. Damit arbeitet die KI als du — Bearbeiter, Historie und Absender stimmen automatisch."
            ),
          ]),
          _vm._v(" "),
          _vm._l(_vm.activeAiTokens, function (token) {
            return _c("div", { key: token.id, staticClass: "is-ai-token" }, [
              _c("div", [
                _c("strong", [_vm._v(_vm._s(token.label))]),
                _vm._v(" "),
                _c(
                  "small",
                  [
                    _vm._v(
                      "erstellt " +
                        _vm._s(_vm.formatDate(token.createdAt)) +
                        " · zuletzt benutzt " +
                        _vm._s(
                          token.lastUsedAt
                            ? _vm.formatDate(token.lastUsedAt)
                            : "nie"
                        ) +
                        " · "
                    ),
                    token.expired
                      ? [
                          _vm._v(
                            "abgelaufen " +
                              _vm._s(_vm.formatDate(token.expiresAt))
                          ),
                        ]
                      : [
                          _vm._v(
                            "gültig bis " +
                              _vm._s(
                                token.expiresAt
                                  ? _vm.formatDate(token.expiresAt)
                                  : "unbegrenzt"
                              )
                          ),
                        ],
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button is-small",
                  on: {
                    click: function ($event) {
                      return _vm.revokeAiToken(token)
                    },
                  },
                },
                [_vm._v("Widerrufen")]
              ),
            ])
          }),
          _vm._v(" "),
          _vm.newAiToken
            ? _c("div", { staticClass: "is-ai-token-new" }, [
                _c("div", { staticClass: "is-ai-token-value" }, [
                  _c("code", [_vm._v(_vm._s(_vm.newAiToken))]),
                  _vm._v(" "),
                  _c(
                    "i",
                    {
                      staticClass: "material-icons is-pointer",
                      on: {
                        click: function ($event) {
                          return _vm.copy(_vm.newAiToken, "Token kopiert!")
                        },
                      },
                    },
                    [_vm._v("content_copy")]
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "help" }, [
                  _vm._v(
                    "Wird nur jetzt angezeigt — kopieren und ins Setup-Skript einfügen."
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "field has-addons" }, [
            _c("div", { staticClass: "control is-expanded" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.aiTokenLabel,
                    expression: "aiTokenLabel",
                  },
                ],
                staticClass: "input",
                attrs: { type: "text", placeholder: "z. B. Codex Laptop" },
                domProps: { value: _vm.aiTokenLabel },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.aiTokenLabel = $event.target.value
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "control" }, [
              _c(
                "button",
                {
                  staticClass: "button is-primary",
                  class: { "is-loading": _vm.aiTokenLoading },
                  on: { click: _vm.createAiToken },
                },
                [_vm._v("KI-Token erzeugen")]
              ),
            ]),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "field is-grouped buttons is-grouped-right" }, [
        !_vm.isLoading
          ? _c(
              "button",
              {
                staticClass: "button is-large is-cancel",
                on: { click: _vm.hideUserSettings },
              },
              [_vm._v("Abbrechen")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button is-primary is-large",
            class: { "is-loading": _vm.isLoading },
            attrs: { disabled: !_vm.isDisabled },
            on: { click: _vm.save },
          },
          [_vm._v("Speichern")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }